import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import PrepareDataTable from "./PrepareDataTable";
import { LeadListContainer, Title } from "./LeadList.styled";
import { leadStatusAll } from "@utils/filterOptions";
import UserInfo from "@utils/UserInfo";
import "./LeadList.scss";

/**
 * Lead List,
 * Path - /leads
 * @see See [Leads Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3427893254/Leads)
 * @component
 */
const LeadList = (props) => {
  const { t, columnList } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [additionalData, setAdditionalData] = useState([]);
  const [loadList, setLoadList] = useState(false);
  const generalParams = useGetGeneralParameters();

  const mainCountryInfo = UserInfo.countryInfo();

  const [countryId, setCountryId] = useState(UserInfo.countryId());
  const [countryList, setCountryList] = useState(
    UserInfo.countryListForFilter(t)
  );

  const [selectedFilter, setSelectedFilter] = useState([]);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  useEffect(() => {
    const countryFilters = [];
    const allFilters = [];
    if (countryList?.length > 0 && Object.keys(generalParams).length > 0) {
      countryFilters.push({
        value: mainCountryInfo?.country?.id,
        label: t(mainCountryInfo?.country?.name),
      });
      allFilters.push({ column: "country", value: countryId });

      const statusList = leadStatusAll(t);
      statusList.map((statusInfo) => {
        allFilters.push({ column: "status", value: statusInfo.value });
      });
      setSelectedFilter([
        ...selectedFilter,
        { column: "country", value: countryFilters },
        { column: "status", value: leadStatusAll(t) },
      ]);
      setAdditionalData(allFilters);
      setLoadList(true);
    }
  }, [countryList, generalParams]);

  return (
    <LeadListContainer className="leads-list">
      <Title>{t("LEADS")}</Title>
      {selectedFilter?.length > 0 && loadList && (
        <PrepareDataTable
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          columnList={columnList}
          countryList={countryList}
          selectedFilter={selectedFilter}
          additionalData={additionalData}
          techAdmin={UserInfo.getUser().techAdmin}
          userCountryId={countryId}
        />
      )}
    </LeadListContainer>
  );
};

LeadList.propTypes = {
  t: PropTypes.func.isRequired,
  objectType: PropTypes.string,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

LeadList.defaultProps = {
  columnList: [],
  objectType: null,
};
export default withTranslation()(LeadList);
